import { useSelector } from "react-redux";
import CardModel from "../../../../../../../Models/CardModel";
import "./Card.css";
import flipSound from "./card-flip.mp3";
import cardSuccess from "./card-success.mp3";
interface CardProps {
  card: CardModel;
  onClick: () => void;
  onSuccess: () => void;
}

function Card({ card, onClick, onSuccess }: CardProps): JSX.Element {
  const cardClasses = ["card"];
  const siteImages = useSelector((state: any) => state.siteImagesSlice);

  const playSuccessSound = () => {
    const audio = new Audio(cardSuccess);
    audio.play();
  };
    
  const playFlipSound = () => {
    const audio = new Audio(flipSound);
    audio.play();
  };

  if (card.isFlipped || card.isMatched) {
    cardClasses.push("flipped");
  }

  const handleClick = () => {
    playFlipSound();
    onClick();
    if (card.isMatched) {
      playSuccessSound();
      onSuccess();
    }
  };

  return (
    <div className="Card">
      <button className={cardClasses.join(" ")} style={{ backgroundImage: `url(${siteImages.imageMemoryCardGame})` }} onClick={handleClick}>
        <p className="card_inner">
            {card.isFlipped || card.isMatched ? card.englishWord : ""}
        </p>
      </button>
    </div>
  );
}

export default Card;
